export type DeprecatedCustomerOperateRoutePageId =
  | "analytics:metrics-2"
  | "analytics:metrics:create-2"
  | "analytics:metrics:details-2"
  | "analytics:metrics:labels-2"
  | "analytics:allocations:labels-2"
  | "analytics:allocations-2"
  | "analytics:allocations:create-2"
  | "analytics:allocations:details-2"
  | "cloudflow-2"
  | "cloudflow:edit-2"
  | "cloudflow:history-2"
  | "cloudflow:details-2"
  | "cloudflow:blueprints-2"
  | "blueprint:details-2"
  | "threads-2"
  | "threads:details-2"
  // attributions -> allocations
  | "analytics:attributions-2"
  | "analytics:attributions:create-2"
  | "analytics:attributions:details-2"
  | "analytics:attribution-groups-2"
  | "analytics:attribution-groups:create-2"
  | "analytics:attribution-groups:edit-2";

export type DeprecatedCustomerOperateRouteConfig = {
  pageId: DeprecatedCustomerOperateRoutePageId;
  route: string;
};

export const deprecatedCustomerOperateRoutes: DeprecatedCustomerOperateRouteConfig[] = [
  {
    pageId: "cloudflow-2",
    route: "/cloudflow",
  },
  {
    pageId: "cloudflow:edit-2",
    route: "/cloudflow/edit/:flowId",
  },
  {
    pageId: "cloudflow:history-2",
    route: "/cloudflow/history",
  },
  {
    pageId: "cloudflow:details-2",
    route: "/cloudflow/history/:executionId",
  },
  {
    pageId: "cloudflow:blueprints-2",
    route: "/cloudflow/blueprints",
  },
  {
    pageId: "blueprint:details-2",
    route: "/blueprint/:flowId",
  },
  {
    pageId: "analytics:metrics-2",
    route: "/analytics/metrics",
  },
  {
    pageId: "analytics:metrics:create-2",
    route: "/analytics/metrics/create",
  },
  {
    pageId: "analytics:metrics:details-2",
    route: "/analytics/metrics/:metricId",
  },
  {
    pageId: "analytics:metrics:labels-2",
    route: "/analytics/metrics/labels",
  },
  {
    pageId: "threads-2",
    route: "/threads",
  },
  {
    pageId: "threads:details-2",
    route: "/threads/:threadId?",
  },
  // "allocations" and attributions -> allocations
  {
    pageId: "analytics:allocations-2",
    route: "/analytics/allocations",
  },
  {
    pageId: "analytics:allocations:labels-2",
    route: "/analytics/allocations/labels",
  },
  {
    pageId: "analytics:allocations:create-2",
    route: "/analytics/allocations/create",
  },
  {
    pageId: "analytics:allocations:details-2",
    route: "/analytics/allocations/:allocationId",
  },
  {
    pageId: "analytics:attributions-2",
    route: "/analytics/attributions",
  },
  {
    pageId: "analytics:attributions:create-2",
    route: "/analytics/attributions/create",
  },
  {
    pageId: "analytics:attributions:details-2",
    route: "/analytics/attributions/:attributionId",
  },
  {
    pageId: "analytics:attribution-groups-2",
    route: "/analytics/attribution-groups",
  },
  {
    pageId: "analytics:attribution-groups:create-2",
    route: "/analytics/attribution-groups/create",
  },
  {
    pageId: "analytics:attribution-groups:edit-2",
    route: "/analytics/attribution-groups/:attributionGroupId",
  },
];
